import constants from "../constants";

const {
  SEND_GET_PROJECT_MANAGERS,
  SEND_ADD_PROJECT_MANAGER,
  SEND_EDIT_PROJECT_MANAGER,
  SEND_REMOVE_PROJECT_MANAGER,
  ADD_PROJECT_MANAGER,
  EDIT_PROJECT_MANAGER,
  REMOVE_PROJECT_MANAGER,
  UPDATE_PROJECT_MANAGERS,
} = constants;

export const sendGetProjectManagers = () => ({
  type: SEND_GET_PROJECT_MANAGERS,
});

export const sendAddProjectManager = (projectManagerData, resolve, reject) => ({
  type: SEND_ADD_PROJECT_MANAGER,
  projectManagerData,
  resolve,
  reject,
});

export const sendUpdateProjectManager = (projectManagerData, resolve, reject) => ({
  type: SEND_EDIT_PROJECT_MANAGER,
  projectManagerData,
  resolve,
  reject,
});

export const sendRemoveProjectManager = (projectManagerUid, resolve, reject) => ({
  type: SEND_REMOVE_PROJECT_MANAGER,
  projectManagerUid,
  resolve,
  reject,
});

export const updateProjectManagersStore = (data) => ({
  type: UPDATE_PROJECT_MANAGERS,
  data,
});

export const addProjectManagerStore = (projectManager, projectManagerUid) => ({
  type: ADD_PROJECT_MANAGER,
  data: { projectManager, projectManagerUid },
});

export const upsertProjectManagerStore = (projectManager, projectManagerUid) => ({
  type: EDIT_PROJECT_MANAGER,
  data: { projectManager, projectManagerUid },
});

export const removeProjectManagerStore = (projectManagerUid) => ({
  type: REMOVE_PROJECT_MANAGER,
  data: { projectManagerUid },
});
